import { useState, useCallback } from 'react';
import { IManualMovement } from '../shared/types';

type StagedMovement = IManualMovement;

export const useStagedMovements = () => {
  const [stagedMovements, setStagedMovements] = useState<StagedMovement[]>([]);

  const addMovement = useCallback((movement: StagedMovement) => {
    setStagedMovements(prev => [...prev, movement]);
  }, []);

  const removeMovement = useCallback((tempId: string) => {
    setStagedMovements(prev => prev.filter(m => m.id !== tempId));
  }, []);

  const clearMovements = useCallback(() => {
    setStagedMovements([]);
  }, []);

  return {
    stagedMovements,
    addMovement,
    removeMovement,
    clearMovements,
  };
};